import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ListDetailsService {
  public static objectCountOnList = new BehaviorSubject<number>(0);
  public static behaviorSubjectChanged = new Subject<void>();
  public static isLoading = new BehaviorSubject<boolean>(false);

  static updateCount(count: number) {
    this.objectCountOnList.next(count);
    this.behaviorSubjectChanged.next();
  }

  static setLoading(loading: boolean) {
    this.isLoading.next(loading);
  }
}
